<div class="export-container">
  <form [formGroup]="form" novalidate>
    <div class="workflow-main-container">
      <div class="workflow-label">
        <wm-common-text
          [data]="{
            text: 'Choose your workflow'
          }"
        ></wm-common-text>
      </div>

      <div class="export-workflow-dropdown">
        <wm-common-dropdown
          [data]="{
            placeholder: 'SELECT WORKFLOW',
            options: exportOptions,
          }"
          [formControl]="name"
          (change)="switchWorkflowOption()"
        >
        </wm-common-dropdown>
      </div>

      <div class="content-center">
        <div *ngIf="exportEntityOptions && exportEntityOptions.length > 0">
          <wm-filter-builder
            #filterCtrl
            *ngIf="params"
            [id]="id"
            [params]="params"
            [filterTypes]="filterTypes"
            [savedFilters]="true"
            [columnOptions]="exportEntityOptions"
            [staffFilterBuilder]="true"
            (columnsChange)="onColumnsChanged($event)"
            (exportColumnsChange)="onExportColumnsChange($event)"
            (filtersChange)="filtersChanged($event)"
            [onlyExportOptions]="true"
            [shapefileValidationCriteria]="shapefileValidationCriteria"
          ></wm-filter-builder>
        </div>

        <router-outlet name="overlay"></router-outlet>

        <div>
          @if ((exportEntityOptions && exportEntityOptions.length > 0 && staticFilters
          && staticFilters.length > 0)) {
          <app-reports-table-header
            [id]="id"
            [title]="title"
            [params]="params"
            [currentFilters]="filters"
            [currentColumnOptions]="exportEntityOptions"
            (exportExcel)="exportExcel()"
            (exportCsv)="exportCsv()"
          ></app-reports-table-header>

          <!-- <pre>{{ selectedWorkflow | json }}</pre> -->
          <ng-container *ngIf="dataSetId || (exportId && exportEntityOptions)">
            <div class="row mt-2 ml-2 p-0">
              <div class="col m-0 p-0">
                <div [hidden]="!exporting">
                  <div class="spinner-border"></div>
                  Exporting...
                </div>
                <div [hidden]="!showDownloadLink">
                  <div>
                    <a
                      class="download-link"
                      [attr.href]="sanitize(link.href)"
                      [attr.download]="link.download"
                    >
                      Download {{ link.download }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          }
        </div>
      </div>
    </div>
  </form>
</div>
